<template>
  <div class="user-projects">
    <div class="user-projects__title">
      Projects
    </div>
    <div class="user-projects-project">
      <div v-for="project in projects"
           :key="project.id"
           class="user-projects-project__item"
           :class="{'user-projects-project__item_disabled': !isKpi}"
           @click="openItem(project.type, project.value)"
      >
        <span class="user-projects-project__color"
              :class="{'user-projects-project__color_disabled': !isKpi}"
        >
          {{project.name}}
        </span>
        <span :class="{'user-projects-project_disabled': !isKpi}">
          AED
          <ICountUp :delay="countUp.delay"
                    :endVal="project.value"
                    :options="countUp.options"/>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import {get} from 'lodash'
export default {
  name: 'UserProjects',
  components: {
    ICountUp
  },
  props: ['userKpi'],
  computed: {
    projects () {
      const earned = get(this.userKpi, 'earned', 0)
      const potential = get(this.userKpi, 'potential', 0)
      const forApproval = get(this.userKpi, 'forApproval', 0)
      return [
        {
          id: 1,
          name: 'Total Completed',
          type: 'earned',
          value: earned
        },
        {
          id: 2,
          name: 'Total Potential',
          type: 'potential',
          value: potential
        },
        {
          id: 3,
          name: 'Pending approval',
          type: 'forApproval',
          value: forApproval
        }
      ]
    },
    isKpi () {
      return get(this.userKpi, ['position', 'kpi'], false)
    }
  },
  data () {
    return {
      countUp: {
        delay: 0,
        options: {
          duration: 0.5,
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          decimalPlaces: 2
        }
      }
    }
  },
  methods: {
    openItem (type, total) {
      this.$emit('openItem', type, total)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.user-projects {
  @include global-font;
  position: relative;
  height: 223px;
  background: $color-white;
  border-radius: 6px;
  padding: 20px 20px;

  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    color: $color-denim;
    margin-bottom: 16px;
  }

  &-project {
    display: grid;
    grid-row-gap: 12px;

    &_disabled {
      color: $color-silver-new;
      background-color: $color-wild-sand;
      border: none;
    }

    &__item {
      padding: 13px 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px solid $color-denim;
      box-sizing: border-box;
      border-radius: 4px;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      cursor: pointer;
      transition: all .3s ease;

      &_disabled {
        pointer-events: none;
        background-color: $color-wild-sand;
        border: none;
      }

      &:hover {
        background: rgba($color-denim, 0.15);
      }
    }

    &__color {
      color: $color-denim;
      font-weight: 600;

      &_disabled {
        color: $color-silver-new;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/UserCard/UserProjects/UserProjects.vue